import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'

interface NumberOfVariantsForDigitProps {}

const NumberOfVariantsForDigit: FC<NumberOfVariantsForDigitProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'numberOfVariantsForDigit'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default NumberOfVariantsForDigit
